import { useEffect } from 'react';
import i18n from '../../../i18n';

/**
 *
 * @returns
 */
const useAppLanguage = () => {
    const isMultiLanguage = sessionStorage.getItem('isMultiLanguage');

    useEffect(() => {
        // Get persisted language from localStorage (same key as i18next detection config)
        const persistedLanguage = localStorage.getItem('language');

        if (persistedLanguage) {
            i18n.changeLanguage(persistedLanguage);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const isEnglish = i18n.language.includes('en');
    const currentLanguage = i18n.language.includes('en') ? 'en' : 'fr';
    const nextLanguage = isEnglish ? 'fr' : 'en';

    const changeLanguage = (toLanguage) => {
        if (currentLanguage === toLanguage) { return; }
        i18n.changeLanguage(toLanguage);
        localStorage.setItem('language', toLanguage);
    };

    return {
        isMultiLanguage, changeLanguage, currentLanguage, nextLanguage,
    };
};

export default useAppLanguage;
